'use client';

import { useSaveTripPrompt } from '~/components/Journey/SaveTripPrompt/useSaveTripPrompt';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { useTripId } from '~/hooks/useTripId';
import { api } from '~/libs/api';

export const TripSaveTripPrompt = () => {
  const tripId = useTripId();
  const { data: overviewData } = api.trip.getOverview.useQuery(
    { tripId },
    { ...TRPC_SETTINGS.QUERY_NO_REFETCH, enabled: !!tripId, keepPreviousData: true }
  );

  useSaveTripPrompt({
    tripId,
    tripTitle: overviewData?.journeyTitle ?? '',
    revealDepthPercent: 25,
    revealScrollUpPercent: 20
  });

  return null;
};
